/** @format */
// Proof Types see order entity \Frontier\Model\Entity\Order
export const PROOF_TYPE_NONE = 1;
export const PROOF_TYPE_ELECTRONIC = 2;
export const PROOF_TYPE_PRINTED = 3;

// If you change this, see the same one in the electron app
export const REGEX_DESIGN_FILENAME = /[^0-9a-zA-Z_\.\-\[\]\(\)]/gi; // eslint-disable-line

export const PROOF_TYPES = [
    {id: PROOF_TYPE_NONE, label: 'No Proof'},
    {id: PROOF_TYPE_ELECTRONIC, label: 'Electronic Proof'},
    {id: PROOF_TYPE_PRINTED, label: 'Printed Proof'}
];

export const DESIGN_QUOTER_STEP_LANDING = 'landing';
export const DESIGN_QUOTER_STEP_QUOTER = 'quoter';
export const DESIGN_QUOTER_STEP_DESIGN_DIRECTION_DESIGN_STYLE = 'design_direction_design_style';
export const DESIGN_QUOTER_STEP_DESIGN_DIRECTION_COLOR_PREFERENCES =
    'design_direction_color_preferences';
export const DESIGN_QUOTER_STEP_DESIGN_DIRECTION_BRAND_AND_PRODUCT =
    'design_direction_brand_and_product';

export const GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_EDITS = 1;
export const GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION = 2;
export const GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN = 3;

export const GRAPHIC_DESIGN_ORDER_TYPES = [
    {id: GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_EDITS, label: 'Artwork Edits'},
    {id: GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION, label: 'Artwork Recreation'},
    {id: GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN, label: 'Custom Design'}
];

export const COLOR_REDS = 1;
export const COLOR_ORANGES = 2;
export const COLOR_YELLOWS = 3;
export const COLOR_GREENS = 4;
export const COLOR_BLUES = 5;
export const COLOR_PURPLES = 6;
export const COLOR_PINKS = 7;
export const COLOR_BROWNS = 8;
export const COLOR_LIGHT_NEUTRALS = 9;
export const COLOR_DARK_NEUTRALS = 10;

export const GRAPHIC_DESIGN_COLOR_TYPES = [
    {
        id: COLOR_REDS,
        label: 'Reds',
        description: 'Energy, Passion, Love',
        image: '/assets/images/quoter/graphic_design/colors/Reds.png'
    },
    {
        id: COLOR_ORANGES,
        label: 'Oranges',
        description: 'Adventure, Creativity, Happiness',
        image: '/assets/images/quoter/graphic_design/colors/Oranges.png'
    },
    {
        id: COLOR_YELLOWS,
        label: 'Yellows',
        description: 'Friendliness, Fun, Youth',
        image: '/assets/images/quoter/graphic_design/colors/Yellows.png'
    },
    {
        id: COLOR_GREENS,
        label: 'Greens',
        description: 'Growth, Nature, Vitality, Wealth',
        image: '/assets/images/quoter/graphic_design/colors/Greens.png'
    },
    {
        id: COLOR_BLUES,
        label: 'Blues',
        description: 'Calm, Knowledge, Trust',
        image: '/assets/images/quoter/graphic_design/colors/Blues.png'
    },
    {
        id: COLOR_PURPLES,
        label: 'Purples',
        description: 'Imagination, Royalty, Luxury',
        image: '/assets/images/quoter/graphic_design/colors/Purples.png'
    },
    {
        id: COLOR_PINKS,
        label: 'Pinks',
        description: 'Nurture, Intimacy, Love',
        image: '/assets/images/quoter/graphic_design/colors/Pinks.png'
    },
    {
        id: COLOR_BROWNS,
        label: 'Browns',
        description: 'Organic, Rugged, Earthy, Old-Fashioned',
        image: '/assets/images/quoter/graphic_design/colors/Browns.png'
    },
    {
        id: COLOR_LIGHT_NEUTRALS,
        label: 'Light Neutrals',
        description: 'Purity, Sophistication, Simplicity',
        image: '/assets/images/quoter/graphic_design/colors/Light-Neutrals.png'
    },
    {
        id: COLOR_DARK_NEUTRALS,
        label: 'Dark Neutrals',
        description: 'Formality, Mystery, Balance',
        image: '/assets/images/quoter/graphic_design/colors/Dark-Neutrals.png'
    }
];

export const GRAPHIC_DESIGN_STYLE_PLAYFUL = 1;
export const GRAPHIC_DESIGN_STYLE_PHOTO = 2;
export const GRAPHIC_DESIGN_STYLE_MINIMAL = 3;
export const GRAPHIC_DESIGN_STYLE_DETAILED = 4;
export const GRAPHIC_DESIGN_STYLE_SKETCH = 5;
export const GRAPHIC_DESIGN_STYLE_VINTAGE = 6;
export const GRAPHIC_DESIGN_STYLE_COMMERCIAL = 7;
export const GRAPHIC_DESIGN_STYLE_LUXURY = 8;

export const GRAPHIC_DESIGN_STYLES = [
    {
        id: GRAPHIC_DESIGN_STYLE_PLAYFUL,
        label: 'Playful',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_PHOTO,
        label: 'Photo',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_MINIMAL,
        label: 'Minimal',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_DETAILED,
        label: 'Detailed',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_SKETCH,
        label: 'Sketch',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_VINTAGE,
        label: 'Vintage',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_COMMERCIAL,
        label: 'Commercial',
        image: '/assets/images/quoter/graphic_design/styles/'
    },
    {
        id: GRAPHIC_DESIGN_STYLE_LUXURY,
        label: 'Luxury',
        image: '/assets/images/quoter/graphic_design/styles/'
    }
];

// See OrderDueCalculator if updating these values
export const PROOF_APPROVAL_CUTOFF = 12;
export const ORDER_CUTOFF = 10;

// Proof Statuses see proof entity \Frontier\Model\Entity\Proof
export const PROOF_STATUS_PENDING = 0;
export const PROOF_STATUS_APPROVED = 1;
export const PROOF_STATUS_DISAPPROVED = 2;

// Proof Internal Statuses \Frontier\Model\Entity\Proof
export const PROOF_INTERNAL_NOT_TRACKING = 1;
export const PROOF_INTERNAL_PRINTING = 8;
export const PROOF_INTERNAL_LAMINATING = 10;
export const PROOF_INTERNAL_CONVERTING = 11;
export const PROOF_INTERNAL_REWINDING = 14;
export const PROOF_INTERNAL_SHIPPING = 17;
export const PROOF_INTERNAL_COMPLETE = 20;

export const PROOF_INTERNAL_STATUSES = [
    {id: PROOF_INTERNAL_NOT_TRACKING, label: 'Not Tracking'},
    {id: PROOF_INTERNAL_PRINTING, label: 'Printing'},
    {id: PROOF_INTERNAL_LAMINATING, label: 'Laminating'},
    {id: PROOF_INTERNAL_CONVERTING, label: 'Converting'},
    {id: PROOF_INTERNAL_REWINDING, label: 'Folding'},
    {id: PROOF_INTERNAL_SHIPPING, label: 'Shipping'},
    {id: PROOF_INTERNAL_COMPLETE, label: 'Complete'}
];

// Proof Design Statuses \Frontier\Model\Entity\DesignsOrder
export const DESIGN_STATUS_NOT_REVIEWED = 1;
export const DESIGN_STATUS_APPROVED = 2;
export const DESIGN_STATUS_DISAPPROVED = 3;

export const DESIGN_PROOF_STATUS = [
    {id: DESIGN_STATUS_NOT_REVIEWED, label: 'Not Reviewed'},
    {id: DESIGN_STATUS_APPROVED, label: 'Approved'},
    {id: DESIGN_STATUS_DISAPPROVED, label: 'Disapproved'}
];

export const DESIGN_DISAPPROVE_REASON_NEW_ARTWORK = 1;
export const DESIGN_DISAPPROVE_REASON_CHANGE_ARTWORK = 2;
export const DESIGN_DISAPPROVE_REASON_CHANGE_ORDER = 3;
export const DESIGN_DISAPPROVE_REASON_FORCED = 4;

export const SIZE_TYPE_STANDARD = 1;
export const SIZE_TYPE_STANDARD_NEW = 2;
export const SIZE_TYPE_CUSTOM_NEW = 3;

export const SIZE_TYPES = [
    {id: SIZE_TYPE_STANDARD, label: 'In-Stock Die'},
    {id: SIZE_TYPE_STANDARD_NEW, label: 'New Standard Shape'},
    {id: SIZE_TYPE_CUSTOM_NEW, label: 'New Custom Shape'}
];

export const EMBOSSING_TYPE_NONE = 1;
export const EMBOSSING_TYPE_ALL = 2;
export const EMBOSSING_TYPE_UNIQUE = 3;

export const EMBOSSING_TYPES = [
    {id: EMBOSSING_TYPE_NONE, label: 'None'},
    {id: EMBOSSING_TYPE_ALL, label: 'Identical Embossing'},
    {id: EMBOSSING_TYPE_UNIQUE, label: 'Unique Embossing'}
];

export const PRODUCT_TYPE_LABEL = 1;
export const PRODUCT_TYPE_CARTON = 2;
export const PRODUCT_TYPE_GRAPHIC_DESIGN = 3;

export const PRODUCT_TYPES = [
    {id: PRODUCT_TYPE_LABEL, label: 'Custom Labels'},
    {id: PRODUCT_TYPE_CARTON, label: 'Custom Cartons'},
    {id: PRODUCT_TYPE_GRAPHIC_DESIGN, label: 'Graphic Design'}
];

export const PRODUCT_TYPES_FOR_SIZES = [
    {id: PRODUCT_TYPE_LABEL, label: 'Custom Labels'},
    {id: PRODUCT_TYPE_CARTON, label: 'Custom Cartons'}
];

export const SIZE_STATUS_PENDING = 1;
export const SIZE_STATUS_APPROVED = 2;
export const SIZE_STATUS_ORDERED = 3;
export const SIZE_STATUS_INSTOCK = 4;
export const SIZE_STATUS_TRASH = 5;

export const SIZE_STATUSES = [
    {id: SIZE_STATUS_PENDING, label: 'Pending'},
    {id: SIZE_STATUS_APPROVED, label: 'Approved'},
    {id: SIZE_STATUS_ORDERED, label: 'Ordered'},
    {id: SIZE_STATUS_INSTOCK, label: 'In-Stock'},
    {id: SIZE_STATUS_TRASH, label: 'Trash'}
];

export const SHAPE_RECTANGLE = 1;
export const SHAPE_CIRCLE = 2;
export const SHAPE_SQUARE = 3;
export const SHAPE_OVAL = 4;
export const SHAPE_CUSTOM = 5;
export const SHAPE_CARTON = 10; // TODO Deprecate
export const SHAPE_CARTON_AUTOLOCK = 10;
export const SHAPE_CARTON_STRAIGHT_TUCK = 11;
export const SHAPE_CARTON_CUSTOM = 55;
export const SHAPE_TAPERED = 20;

export const SHAPE_TYPES = [
    {
        id: SHAPE_RECTANGLE,
        label: 'Rectangle (with tw-rounded corners)',
        is_square_corners: false
    },
    {
        id: SHAPE_RECTANGLE,
        label: 'Rectangle (with square corners)',
        is_square_corners: true
    },
    {
        id: SHAPE_SQUARE,
        label: 'Square (with tw-rounded corners)',
        is_square_corners: false
    },
    {id: SHAPE_SQUARE, label: 'Square (with square corners)', is_square_corners: true},
    {
        id: SHAPE_CIRCLE,
        label: 'Circle',
        is_square_corners: false
    },
    {
        id: SHAPE_OVAL,
        label: 'Oval',
        is_square_corners: false
    },
    {
        id: SHAPE_CUSTOM,
        label: 'Custom',
        is_square_corners: false
    }
];

export const CARTON_SHAPE_TYPES = [
    {id: SHAPE_CARTON_AUTOLOCK, label: 'Auto Lock'},
    {id: SHAPE_CARTON_STRAIGHT_TUCK, label: 'Straight Tuck End'},
    {id: SHAPE_CARTON_CUSTOM, label: 'Custom Carton'}
];

export const CUSTOM_FOLDING_AUTOLOCK = 1;
export const CUSTOM_FOLDING_STRIAGHT_LINE = 2;
export const CUSTOM_FOLDING_NONE = 3;
export const CARTON_CUSTOM_FOLDING_STYLES = [
    {id: CUSTOM_FOLDING_AUTOLOCK, label: 'Auto Lock'},
    {id: CUSTOM_FOLDING_STRIAGHT_LINE, label: 'Straight Line'},
    {id: CUSTOM_FOLDING_NONE, label: 'None'}
];

// Order Statuses see order entity \Frontier\Model\Entity\Order
export const ORDER_STATUS_IN_CART = 100;
export const ORDER_STATUS_QUOTE_SAVED = 200;
export const ORDER_STATUS_QUOTE = 300;
export const ORDER_STATUS_BILLING_CUE = 1;
export const ORDER_STATUS_BILLING_IN_PROGRESS = 2;
export const ORDER_STATUS_NEEDS_ASSISTANCE = 3;
export const ORDER_STATUS_PREPRINTING_CUE = 4;
export const ORDER_STATUS_PREPRINTING_IN_PROGRESS = 5;
export const ORDER_STATUS_WAITING_ON_CUSTOMER = 6;
export const ORDER_STATUS_PREPRINTING_QC = 7;
export const ORDER_STATUS_PRINTING_CUE = 8;
export const ORDER_STATUS_PRINTING_IN_PROGRESS = 9;
export const ORDER_STATUS_LAMINATING_CUE = 10;
export const ORDER_STATUS_CONVERTING_CUE = 11;
export const ORDER_STATUS_CONVERTING_IN_PROGRESS = 12;
export const ORDER_STATUS_BLANKING_CUE = 13;
export const ORDER_STATUS_REWINDING_CUE = 14;
export const ORDER_STATUS_REWINDING_IN_PROGRESS = 15;
export const ORDER_STATUS_REWINDING_QC = 16;
// STATUSES ARE DIFFERENT HERE, QC COMES FIRST!!!!!!
export const ORDER_STATUS_SHIPPING_QC = 17;
export const ORDER_STATUS_SHIPPING_CUE = 18;
export const ORDER_STATUS_SHIPPING_IN_PROGRESS = 19;
export const ORDER_STATUS_COMPLETE = 20;

export const ORDER_STANDARD_PROCESSING = 1;
export const ORDER_EXPEDITED_PROCESSING = 2;

export const PROCESSING_TYPES = [
    {id: ORDER_STANDARD_PROCESSING, label: 'Standard'},
    {id: ORDER_EXPEDITED_PROCESSING, label: 'Expedited'}
];

export const MAXIMUM_ROLL_DIAMETER = 13;

export const TASK_PROCESSED_CONTACT = 1;
export const TASK_ASSIST = 17;
export const TASK_EMAIL_SENT = 18;
export const TASK_CALL_SENT = 19;
export const TASK_SHIPPED = 2;
export const TASK_BILLED = 3;
export const TASK_PROOFED_ELECTRONIC = 4;
export const TASK_PREPRINTED = 5;
export const TASK_CONVERTED = 7;
export const TASK_PRINTED = 6;
export const TASK_LAMINATED = 22;
export const TASK_BLANKED = 23;
export const TASK_REWOUND = 8;
export const TASK_PROOFED_PRINTED = 10;
export const TASK_PROOF_PRINTED = 11;
export const TASK_PROOF_CONVERTED = 12;
export const TASK_PROOF_SHIPPED = 13;
export const TASK_PHONE_CALL = 14;
export const TASK_QC_SHIPMENT = 15;
export const TASK_ORDERED = 16;

export const TASK_ICONS = {
    [TASK_PROCESSED_CONTACT]: 'fa-check-circle',
    [TASK_ASSIST]: 'fa-hands-helping',
    [TASK_EMAIL_SENT]: 'fa-envelope',
    [TASK_CALL_SENT]: 'fa-phone',
    [TASK_SHIPPED]: 'fa-truck',
    [TASK_BILLED]: 'fa-file-invoice',
    [TASK_PROOFED_ELECTRONIC]: 'fa-clipboard-check',
    [TASK_PREPRINTED]: 'fa-print',
    [TASK_CONVERTED]: 'fa-exchange-alt',
    [TASK_PRINTED]: 'fa-print',
    [TASK_LAMINATED]: 'fa-layer-group',
    [TASK_BLANKED]: 'fa-box',
    [TASK_REWOUND]: 'fa-redo',
    [TASK_PROOFED_PRINTED]: 'fa-clipboard-check',
    [TASK_PROOF_PRINTED]: 'fa-clipboard-check',
    [TASK_PROOF_CONVERTED]: 'fa-sync-alt',
    [TASK_PROOF_SHIPPED]: 'fa-truck',
    [TASK_PHONE_CALL]: 'fa-phone',
    [TASK_QC_SHIPMENT]: 'fa-clipboard-check',
    [TASK_ORDERED]: 'fa-shopping-cart'
};

export const FORM_FACTOR_HAND_APPLIED = 1;
export const FORM_FACTOR_INDIVIDUAL_LABELS = 2;
export const FORM_FACTOR_ROLLS = 3;

export const FORM_FACTORS = [
    {id: FORM_FACTOR_ROLLS, label: 'Machine Applied (Rolls)', icon: 'machine'},
    {id: FORM_FACTOR_HAND_APPLIED, label: 'Hand Applied (Rolls)', icon: 'hand'},
    {
        id: FORM_FACTOR_INDIVIDUAL_LABELS,
        label: 'Hand Applied (Stacks)',
        icon: 'stacks',
        // extra: '*',
        tooltip: '+1 day processing. Labels must be cut from rolls into individual labels.'
    }
];

export const ROLL_DIRECTION_TOP = 1;
export const ROLL_DIRECTION_BOTTOM = 2;
export const ROLL_DIRECTION_RIGHT = 3;
export const ROLL_DIRECTION_LEFT = 4;

export const ROLL_DIRECTIONS = [
    {id: ROLL_DIRECTION_TOP, label: 'Label out top first (LOT)'},
    {id: ROLL_DIRECTION_BOTTOM, label: 'Label out bottom first (LOB)'},
    {id: ROLL_DIRECTION_RIGHT, label: 'Label out right first (LOR)'},
    {id: ROLL_DIRECTION_LEFT, label: 'Label out left first (LOL)'}
    // {id: 5, label: 'Label in top first (LIT)'},
    // {id: 6, label: 'Label in bottom first (LIB)'},
    // {id: 7, label: 'Label in right first (LIR)'},
    // {id: 8, label: 'Label in left first (LIF)'}
];

export const CART_PENDING_STATUS = 10;
export const CART_READY_STATUS = 12;
export const CART_COMPLETE_STATUS = 20;
export const CART_ABANDONED_STATUS = 30;

export const METHOD_CREDIT_CARD = 10;
export const METHOD_BILL_LATER = 20;
export const METHOD_NET30 = 30;

export const LAMINATE_GLOSS_FINISH = 1;
export const LAMINATE_MATTE_FINISH = 2;
export const LAMINATE_UV_GLOSS_FINISH = 3;
export const LAMINATE_THERMAL_GLOSS_FINISH = 5;
export const LAMINATE_NO_LAMINATE = 6;
export const LAMINATE_SOFT_TOUCH_MATTE = 7;
export const LAMINATE_HOLO = 8;
export const LAMINATE_LEATHER = 9;
export const LAMINATE_LINEN = 10;

export const LAMINATES = [
    {
        id: LAMINATE_GLOSS_FINISH,
        label: 'Gloss Laminate',
        info: 'High-shine, eye-catching protection. Ideal for enriching colors, preventing ink smearing. Great for health supplements and beauty products.',
        url: '/finishes/gloss-laminate',
        image: 'Gloss-Out.webp',
        hoverImage: 'Gloss-In.webp',
        color: 'Green'
    },
    {
        id: LAMINATE_UV_GLOSS_FINISH,
        label: 'UV Gloss',
        info: 'Glossy, water-resistant, sun-protective laminate. Perfect for outdoor applications. Acts as a sunscreen, ensures label vibrancy against fading and smearing.',
        url: '/finishes/uv-resistant-gloss-laminate',
        image: 'Gloss-Out.webp',
        hoverImage: 'Gloss-In.webp',
        color: 'Red'
    },
    {
        id: LAMINATE_MATTE_FINISH,
        label: 'Matte',
        info: 'Refined, upscale, smudge-resistant finish. Ideal for wine labels, gourmet food, coffee, health and beauty packaging.',
        url: '/finishes/matte-laminate',
        image: 'Satin-Out.webp',
        hoverImage: 'Satin-In.webp',
        color: 'Purple'
    },
    // {id: LAMINATE_THERMAL_GLOSS_FINISH, label: 'Thermal Gloss'},
    {id: LAMINATE_NO_LAMINATE, label: 'No Laminate'},
    {
        id: LAMINATE_SOFT_TOUCH_MATTE,
        label: 'Soft Touch Matte',
        info: 'Soft, luxurious velvet feel. Scuff-proof, ensuring lasting beauty. Perfect for luxury cosmetics, candles, CBD, and more.',
        url: '/finishes/soft-touch-matte-laminate',
        image: 'Matte-Out.webp',
        hoverImage: 'Matte-In.webp',
        color: 'Orange'
    },
    // {
    //     id: LAMINATE_HOLO,
    //     label: 'Rainbow Holographic',
    //     info: 'Rainbow Holographic Plastic laminate is highly reflective and iridescent, adding a rainbow shimmer to any design.',
    //     url: '/finishes/holographic-laminate',
    //     image: 'Rainbow-Out.webp',
    //     hoverImage: 'Rainbow-In.webp',
    //     color: 'Blue'
    // },
    {
        id: LAMINATE_LEATHER,
        label: 'Leather',
        info: 'Non-reflective, stylish, adding a leather-like appearance. Transforms labels without a high price. Ideal for men’s skincare, luxury household items.',
        url: '/finishes/leather-laminate',
        image: 'Leather-Out.webp',
        hoverImage: 'Leather-In.webp',
        color: 'Black'
    },
    {
        id: LAMINATE_LINEN,
        label: 'Linen',
        info: 'A linen-textured look, protective laminate with a bespoke look. Subtle sheen, smooth touch. Ideal for wine, candles, food, and artisan products.',
        url: '/finishes/linen-laminate',
        image: 'Linen-Out.webp',
        hoverImage: 'Linen-In.webp',
        color: 'White'
    }
];

export const CARTON_LAMINATES = [
    {
        id: LAMINATE_GLOSS_FINISH,
        label: 'Gloss',
        info: 'High-shine, eye-catching protection. Ideal for enriching colors, preventing ink smearing. Great for health supplements and beauty products.',
        url: '/finishes/gloss-laminate',
        image: 'Gloss-Out.webp',
        hoverImage: 'Gloss-In.webp'
    },
    {
        id: LAMINATE_MATTE_FINISH,
        label: 'Matte',
        info: 'Refined, upscale, smudge-resistant finish. Ideal for wine labels, gourmet food, coffee, health and beauty packaging.',
        url: '/finishes/matte-laminate',
        image: 'Satin-Out.webp',
        hoverImage: 'Satin-In.webp'
    },
    {
        id: LAMINATE_SOFT_TOUCH_MATTE,
        label: 'Soft Touch Matte',
        info: 'Soft, luxurious velvet feel. Scuff-proof, ensuring lasting beauty. Perfect for luxury cosmetics, candles, CBD, and more.',
        url: '/finishes/soft-touch-matte-laminate',
        image: 'Matte-Out.webp',
        hoverImage: 'Matte-In.webp'
    },
    // {
    //     id: LAMINATE_HOLO,
    //     label: 'Rainbow Holographic',
    //     info: 'Rainbow Holographic Plastic laminate is highly reflective and iridescent, adding a rainbow shimmer to any design.',
    //     url: '/finishes/holographic-laminate',
    //     image: 'Rainbow-Out.webp',
    //     hoverImage: 'Rainbow-In.webp'
    // },
    {
        id: LAMINATE_LEATHER,
        label: 'Leather',
        info: 'Non-reflective, stylish, adding a leather-like appearance. Transforms labels without a high price. Ideal for men’s skincare, luxury household items.',
        url: '/finishes/leather-laminate',
        image: 'Leather-Out.webp',
        hoverImage: 'Leather-In.webp'
    },
    {
        id: LAMINATE_LINEN,
        label: 'Linen',
        info: 'A linen-textured look, protective laminate with a bespoke look. Subtle sheen, smooth touch. Ideal for wine, candles, food, and artisan products.',
        url: '/finishes/linen-laminate',
        image: 'Linen-Out.webp',
        hoverImage: 'Linen-In.webp'
    }
];

export const LABEL_CATEGORY_ID = 1;
export const DESIGN_CATEGORY_ID = 2;

export const ORDER_CHANGE_CATEGORIES = [
    {id: LABEL_CATEGORY_ID, label: 'Labels'},
    {id: DESIGN_CATEGORY_ID, label: 'Designs'}
];

export const COMPENSATION_FAVOR_ID = 1;
export const COMPENSATION_STRIKE_ID = 2;
export const COMPENSATION_SYSTEM_ID = 3;

export const COMPENSATION_TYPES = [
    {id: COMPENSATION_FAVOR_ID, label: 'Favor'},
    {id: COMPENSATION_STRIKE_ID, label: 'Strike'},
    {id: COMPENSATION_SYSTEM_ID, label: 'System'}
];

export const SUBSTRATE_WHITE_PLASTIC = 1;
export const SUBSTRATE_WHITE_PLASTIC_REMOVABLE = 2;
export const SUBSTRATE_CLEAR_PLASTIC = 3;
export const SUBSTRATE_ULTRA_CLEAR_PLASTIC = 4;
export const SUBSTRATE_WHITE_PAPER = 5;
export const SUBSTRATE_SILVER_METALLIC_PAPER = 6;
export const SUBSTRATE_SILVER_METALLIC_PLASTIC = 7;
export const SUBSTRATE_WHITE_VINYL = 8;
export const SUBSTRATE_CLEAR_VINYL = 9;
export const SUBSTRATE_ESTATE4_PAPER = 10;
export const SUBSTRATE_ESTATE9_PAPER = 11;
export const SUBSTRATE_RECYCLED_PAPER = 12;
export const SUBSTRATE_TERRA_SKIN = 13;
export const SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC = 14;
export const SUBSTRATE_KRAFT_PAPER = 15;
export const SUBSTRATE_AVON_CLASSIC_CREST = 16;
export const SUBSTRATE_WHITE_PAPER_HIGH_TACK = 17;
export const SUBSTRATE_WHITE_PLASTIC_SQUEEZABLE = 18;
export const SUBSTRATE_CUSTOM_MATERIAL = 19; // Hidden
export const SUBSTRATE_BLACK_VELLUM = 20;

// CARTON
export const CARTON_BRIGHT_WHITE_PAPER = 100;
export const CARTON_UNLAMINATED_WHITE_PAPER = 101;
export const CARTON_WHITE_PAPER = 102;
export const CARTON_WHITE_PAPER_C2S = 103;
export const CARTON_METALLIC_PAPER = 106;
export const CARTON_BLACK_VELLUM = 120;
export const CARTON_HOLOGRAPHIC = 114;

export const CARTON_SUBSTRATES = [
    {
        id: CARTON_BRIGHT_WHITE_PAPER,
        value: CARTON_BRIGHT_WHITE_PAPER,
        label: 'Bright White Paper (SBS)',
        info: 'Popular 92 Brightness SBS board option. Great for dry goods, oil-resistant with added coating. 100% Blue Bin recyclable and FSC® certified Durable 18pt thickness.',
        url: '/carton-materials/white-paper-cartons',
        image: '/assets/images/quoter/material/carton/White Paper-Out.webp',
        hoverImage: '/assets/images/quoter/material/carton/White Paper-In.webp'
    },
    {
        id: CARTON_UNLAMINATED_WHITE_PAPER,
        value: CARTON_UNLAMINATED_WHITE_PAPER,
        label: 'White Vellum Paper',
        url: '/custom-cartons/white-vellum-paper-cartons',
        info: 'A premium white paperboard with a matte-like uncoated finish, perfect for products that value authenticity and environmental responsibility.',
        image: '/assets/images/quoter/carton_laminate/White Paper/No Laminate-Out.webp',
        hoverImage: '/assets/images/quoter/carton_laminate/White Paper/No Laminate-In.webp'
        // image: '/assets/images/quoter/material/carton/White Paper-Out.webp',
        // hoverImage: '/assets/images/quoter/material/carton/White Paper-In.webp'
    },
    {
        id: CARTON_WHITE_PAPER,
        value: CARTON_WHITE_PAPER,
        label: 'White Paper (FBB)',
        info: 'Economical & Sustainable, 89 Brightness FBB board. Suitable for dry goods not exposed to oil/water. Durable 18pt thickness, 100% Blue Bin recyclable and FSC®, SFI®, and PEFC® certified.',
        url: '/carton-materials/white-paper-cartons',
        image: '/assets/images/quoter/material/carton/White Paper-Out.webp',
        hoverImage: '/assets/images/quoter/material/carton/White Paper-In.webp'
    },
    // { // Chosen using the advanced option for moisture resistance
    //     id: CARTON_WHITE_PAPER_C2S,
    //     value: CARTON_WHITE_PAPER_C2S,
    //     label: 'Bright White Paper (SBS C2S)',
    //     info: 'Moisture Resistant',
    //     url: '/carton-materials/white-paper-cartons',
    //     image: '/assets/images/quoter/material/carton/White Paper-Out.webp',
    //     hoverImage: '/assets/images/quoter/material/carton/White Paper-In.webp'
    // },

    {
        id: CARTON_METALLIC_PAPER,
        value: CARTON_METALLIC_PAPER,
        label: 'Metallic Paper',
        info: 'Radiant, sophisticated foil-like material for indoor use. 100% Blue Bin recyclable. Popular choice for CBD products, vitamins, specialty foods, premium candles.',
        url: '/carton-materials/metallic-paper-cartons',
        image: '/assets/images/quoter/material/carton/Metallic Paper-Out.webp',
        hoverImage: '/assets/images/quoter/material/carton/Metallic Paper-In.webp'
    },
    {
        id: CARTON_HOLOGRAPHIC,
        value: CARTON_HOLOGRAPHIC,
        label: 'Holographic Paper',
        info: 'Eye-catching foil-like iridescent look best suited for indoor use. 100% Blue Bin recyclable. Ideal for CBD, vitamins, specialty foods, premium candles.',
        url: '/carton-materials/holographic-cartons',
        image: '/assets/images/quoter/material/carton/Rainbow-Out.webp',
        hoverImage: '/assets/images/quoter/material/carton/Rainbow-In.webp'
    },
    {
        id: CARTON_BLACK_VELLUM,
        value: CARTON_BLACK_VELLUM,
        label: 'Black Vellum',
        info: 'Sophisticated ultra-black paper, strong color contrast and suave look. 100% Blue Bin recyclable and eco-friendly. Great for artisan products and high-end beauty products.',
        url: '/carton-materials/black-vellum-cartons',
        image: '/assets/images/quoter/material/carton/Black Vellum-Out.webp',
        hoverImage: '/assets/images/quoter/material/carton/Black Vellum-In.webp'
    }
];

export const SUBSTRATES = [
    {
        id: SUBSTRATE_WHITE_PLASTIC,
        label: 'White Plastic',
        info: 'Popular label material well-suited for indoor applications, waterproof, durable, cost-efficient. Ideal for various applications.',
        url: '/label-materials/white-plastic-labels',
        image: '/assets/images/quoter/material/White Plastic-Out.webp',
        hoverImage: '/assets/images/quoter/material/White Plastic-In.webp'
    },
    {
        id: SUBSTRATE_SILVER_METALLIC_PLASTIC,
        label: 'Metallic Plastic',
        info: 'Durable, waterproof, oil-resistant label with a foil-like appearance. Great for vitamins, cosmetics, and CBD oils.',
        url: '/label-materials/metallic-plastic-labels',
        image: '/assets/images/quoter/material/Metallic-Out.webp',
        hoverImage: '/assets/images/quoter/material/Metallic-In.webp'
    },
    {
        id: SUBSTRATE_WHITE_PAPER,
        label: 'White Paper',
        info: 'Affordable, indoor material suitable for dry goods not exposed to oil/water. Offers value and design flexibility.',
        url: '/label-materials/white-paper-labels',
        image: '/assets/images/quoter/material/White Plastic-Out.webp',
        hoverImage: '/assets/images/quoter/material/White Plastic-In.webp'
    },
    {
        id: SUBSTRATE_WHITE_VINYL,
        label: 'White Vinyl',
        info: 'Tough, waterproof label material for indoor/outdoor use. Perfect for industrial and commercial products.',
        url: '/label-materials/white-vinyl-labels',
        image: '/assets/images/quoter/material/White Plastic-Out.webp',
        hoverImage: '/assets/images/quoter/material/White Plastic-In.webp'
    },
    {
        id: SUBSTRATE_AVON_CLASSIC_CREST,
        label: 'Avon Classic Crest®',
        info: 'Premium white paper, moisture-resistant, smooth texture. FSC certified, acid-free, and eco-friendly.',
        url: '/label-materials/avon-crest-paper-labels',
        image: '/assets/images/quoter/material/Avon-Out.webp',
        hoverImage: '/assets/images/quoter/material/Avon-In.webp'
    },
    {
        id: SUBSTRATE_ULTRA_CLEAR_PLASTIC,
        label: 'Ultra-Clear Plastic',
        info: 'Maximum transparency, waterproof, oil-resistant labels. Mimics screen-printed packaging.',
        url: '/label-materials/ultra-clear-plastic-labels',
        image: '/assets/images/quoter/material/Ultra Clear-Out.webp',
        hoverImage: '/assets/images/quoter/material/Ultra Clear-In.webp'
    },
    {
        id: SUBSTRATE_CLEAR_PLASTIC,
        label: 'Clear Plastic',
        info: 'Popular, translucent label material, waterproof, and oil-resistant. Frequently used for supplements, candles, and cosmetics.',
        url: '/label-materials/clear-plastic-labels',
        image: '/assets/images/quoter/material/Clear-Out.webp',
        hoverImage: '/assets/images/quoter/material/Clear-In.webp'
    },
    {
        id: SUBSTRATE_ESTATE4_PAPER,
        label: 'Estate 4 Paper',
        info: 'Premium, water-resistant paper with ribbed texture. Ideal for candle labels, food packaging, and wine labeling.',
        url: '/label-materials/estate-4-paper-labels',
        image: '/assets/images/quoter/material/Estate-Out.webp',
        hoverImage: '/assets/images/quoter/material/Estate-In.webp'
    },
    {
        id: SUBSTRATE_TERRA_SKIN,
        label: 'TerraSkin®',
        info: ' Unique 80% calcium carbonate, 20% polyethylene material. Eco-friendly, sustainable, water-resistant, durable. Ideal for organic products.',
        url: '/label-materials/terraskin-labels',
        image: '/assets/images/quoter/material/White Plastic-Out.webp',
        hoverImage: '/assets/images/quoter/material/White Plastic-In.webp'
    },
    {
        id: SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
        label: 'Rainbow Holographic',
        info: 'Eye-catching labels with a mesmerizing effect. Waterproof, tearproof, temperature-resistant. Ideal for nutraceuticals, beauty products, beverages.',
        url: '/label-materials/holographic-labels',
        image: '/assets/images/quoter/material/Rainbow-Out.webp',
        hoverImage: '/assets/images/quoter/material/Rainbow-In.webp'
    },
    {
        id: SUBSTRATE_KRAFT_PAPER,
        label: 'Kraft Paper',
        info: 'Highly opaque, 100% recycled, eco-friendly label material. Ideal for coffee, gourmet food, pet products, and soap packaging.',
        url: '/label-materials/kraft-paper-labels',
        image: '/assets/images/quoter/material/Kraft-Out.webp',
        hoverImage: '/assets/images/quoter/material/Kraft-In.webp'
    },
    {
        id: SUBSTRATE_BLACK_VELLUM,
        label: 'Black Vellum',
        info: 'Sophisticated, ultra-black paper for high color contrast. Water-resistant, great for wine, beer, candles, and beauty products.',
        url: '/label-materials/black-vellum-labels',
        image: '/assets/images/quoter/material/Black Vellum-Out.webp',
        hoverImage: '/assets/images/quoter/material/Black Vellum-In.webp'
    },
    {
        id: SUBSTRATE_WHITE_PLASTIC_REMOVABLE,
        label: 'Removable Plastic',
        info: 'Suitable for window/door installation, food packaging, inventorying. Leaves no glue residue. Flexible and durable.',
        url: '/label-materials/removable-labels',
        image: '/assets/images/quoter/material/White Plastic-Out.webp',
        hoverImage: '/assets/images/quoter/material/White Plastic-In.webp'
    }
    // {id: SUBSTRATE_SILVER_METALLIC_PAPER, label: 'Silver Metallic Paper'},
    // {id: SUBSTRATE_CLEAR_VINYL, label: 'Clear Vinyl'},
    // {id: SUBSTRATE_ESTATE9_PAPER, label: 'Estate 9 Paper'},
    // {id: SUBSTRATE_RECYCLED_PAPER, label: 'Recycled Paper'},
    // {id: SUBSTRATE_WHITE_PAPER_HIGH_TACK, label: 'White Paper High Tack'},
    // {id: SUBSTRATE_WHITE_PLASTIC_SQUEEZABLE, label: 'White Plastic Squeezable'},
];

export const SUBSTRATE_DEFAULT_HIGH_OPACITY_WHITE = [SUBSTRATE_KRAFT_PAPER, SUBSTRATE_BLACK_VELLUM];

/**
 * Measured at the shipping table with micrometre
 */
export const SUBSTRATE_THICKNESSES = [
    {id: SUBSTRATE_WHITE_PLASTIC, default: 0.0064},
    {id: SUBSTRATE_WHITE_PLASTIC_REMOVABLE, default: 0.0064},
    {id: SUBSTRATE_CLEAR_PLASTIC, default: 0.00625},
    {id: SUBSTRATE_ULTRA_CLEAR_PLASTIC, default: 0.0046, withHighOpacityWhite: 0.0051},
    {id: SUBSTRATE_WHITE_PAPER, default: 0.00665},
    {id: SUBSTRATE_SILVER_METALLIC_PAPER, default: 0},
    {id: SUBSTRATE_SILVER_METALLIC_PLASTIC, default: 0.0061},
    {id: SUBSTRATE_WHITE_VINYL, default: 0.0074},
    {id: SUBSTRATE_ESTATE4_PAPER, default: 0.0092},
    {id: SUBSTRATE_TERRA_SKIN, default: 0.0081},
    {id: SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC, default: 0.00712},
    {id: SUBSTRATE_KRAFT_PAPER, default: 0.00768},
    {id: SUBSTRATE_AVON_CLASSIC_CREST, default: 0.00846},
    {id: SUBSTRATE_BLACK_VELLUM, default: 0.00795}
];

export const SUBSTRATE_BACKING_PAPER = 1;
export const SUBSTRATE_BACKING_POLY = 2;

export const SUBSTRATE_BACKINGS = [
    {id: SUBSTRATE_BACKING_PAPER, label: 'Paper'},
    {id: SUBSTRATE_BACKING_POLY, label: 'Poly'}
];

export const CUSTOMIZABLE_BACKING_SUBSTRATES = [SUBSTRATE_WHITE_PLASTIC];

const SUBSTRATE_BACKING_DEFAULTS = {};
SUBSTRATES.map(substrate => {
    const defaultPolyBackingSubstrates = [
        SUBSTRATE_KRAFT_PAPER,
        SUBSTRATE_BLACK_VELLUM,
        SUBSTRATE_WHITE_PLASTIC,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC
    ];
    if (defaultPolyBackingSubstrates.includes(substrate.id)) {
        SUBSTRATE_BACKING_DEFAULTS[substrate.id] = SUBSTRATE_BACKING_POLY;
    } else {
        SUBSTRATE_BACKING_DEFAULTS[substrate.id] = SUBSTRATE_BACKING_PAPER;
    }
});

export {SUBSTRATE_BACKING_DEFAULTS};

export const getRollDirections = id => {
    return ROLL_DIRECTIONS.find(dir => dir.id === id).label;
};
export const substrates = id => {
    return SUBSTRATES.find(sub => sub.id === id).label;
};

// UPDATE Substrate.php if you change these values
export const DISCONTINUED_SUBSTRATES = [
    {
        id: SUBSTRATE_ESTATE9_PAPER,
        replacements: [SUBSTRATE_ESTATE4_PAPER]
    },
    {
        id: SUBSTRATE_WHITE_PLASTIC_SQUEEZABLE,
        replacements: [SUBSTRATE_WHITE_PLASTIC]
    },
    {
        id: SUBSTRATE_SILVER_METALLIC_PAPER,
        replacements: [SUBSTRATE_SILVER_METALLIC_PLASTIC]
    }
];

export const DISCONTINUED_LAMINATES = [
    {
        id: LAMINATE_HOLO,
        isNewSubstrateRequired: true,
        replacements: [SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC],
        recommendation:
            'Please use our Rainbow Holographic material instead. Please contact us about the differences before ordering.'
    }
];

// Includes Discontinued
// But these may still be able to be reordered
export const DISCONTINUED_NEW_ORDER_SUBSTRATES = DISCONTINUED_SUBSTRATES.concat([]);

export const isSubstrateBackordered = substrateId => {
    const backorderedSubstrate = databaseConstants.backorderedSubstrates.find(
        ({id}) => id === parseInt(substrateId)
    );

    if (backorderedSubstrate) {
        return true;
    }

    return false;
};

export const SUBSTRATES_IMAGE_GROUP = [
    {id: SUBSTRATE_WHITE_PAPER, group: 'White'},
    {id: SUBSTRATE_WHITE_PLASTIC, group: 'White'},
    {id: SUBSTRATE_WHITE_VINYL, group: 'White'},
    {id: SUBSTRATE_WHITE_PAPER, group: 'White'},
    {id: SUBSTRATE_AVON_CLASSIC_CREST, group: 'White'},
    {id: SUBSTRATE_TERRA_SKIN, group: 'White'},
    {id: SUBSTRATE_WHITE_PLASTIC_REMOVABLE, group: 'White'},
    {id: SUBSTRATE_CLEAR_PLASTIC, group: 'Clear'},
    {id: SUBSTRATE_ULTRA_CLEAR_PLASTIC, group: 'Ultra Clear'},
    {id: SUBSTRATE_SILVER_METALLIC_PLASTIC, group: 'Metallic'},
    {id: SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC, group: 'Rainbow'},
    {id: SUBSTRATE_ESTATE4_PAPER, group: 'none'},
    {id: SUBSTRATE_ESTATE9_PAPER, group: 'none'},
    {id: SUBSTRATE_KRAFT_PAPER, group: 'none'},
    {id: SUBSTRATE_AVON_CLASSIC_CREST, group: 'none'},
    {id: SUBSTRATE_BLACK_VELLUM, group: 'none'}
];

export const NO_LAMINATE_SUBSTRATES = [
    SUBSTRATE_ESTATE4_PAPER,
    SUBSTRATE_ESTATE9_PAPER,
    SUBSTRATE_KRAFT_PAPER,
    SUBSTRATE_AVON_CLASSIC_CREST,
    SUBSTRATE_BLACK_VELLUM,
    CARTON_BLACK_VELLUM,
    CARTON_UNLAMINATED_WHITE_PAPER
];

export const SUBSTRATE_SPOTWHITE_REQUIRED = [
    SUBSTRATE_SILVER_METALLIC_PAPER,
    SUBSTRATE_SILVER_METALLIC_PLASTIC,
    SUBSTRATE_CLEAR_PLASTIC,
    SUBSTRATE_CLEAR_VINYL,
    SUBSTRATE_ULTRA_CLEAR_PLASTIC,
    SUBSTRATE_KRAFT_PAPER,
    SUBSTRATE_BLACK_VELLUM
];

export const COLOR_4C = 1;
export const COLOR_5C = 2;
export const COLOR_BLACK_ONLY = 3;
export const COLOR_DOUBLE_SIDED = 4;
export const COLOR_WHITE_ONLY = 9;

export const COLORS = [
    {id: COLOR_4C, label: 'Color (4/C)'},
    {id: COLOR_5C, label: 'Color with White (5/C)'},
    {id: COLOR_BLACK_ONLY, label: 'Black Ink Only'},
    {id: COLOR_DOUBLE_SIDED, label: 'Double Sided (9/C)'},
    {id: COLOR_WHITE_ONLY, label: 'White Ink Only'}
];

export const DUPLEX_SUBSTRATES = [
    CARTON_WHITE_PAPER_C2S,
    CARTON_BLACK_VELLUM,
    CARTON_UNLAMINATED_WHITE_PAPER,
    CARTON_BRIGHT_WHITE_PAPER,
    CARTON_WHITE_PAPER
];

export const COLOR_CAPATIBILITY_MATRIX = {
    [COLOR_4C]: [
        SUBSTRATE_WHITE_PLASTIC,
        SUBSTRATE_WHITE_PLASTIC_REMOVABLE,
        SUBSTRATE_WHITE_PAPER,
        SUBSTRATE_WHITE_VINYL,
        SUBSTRATE_ESTATE4_PAPER,
        SUBSTRATE_ESTATE9_PAPER,
        SUBSTRATE_RECYCLED_PAPER,
        SUBSTRATE_TERRA_SKIN,
        SUBSTRATE_AVON_CLASSIC_CREST,
        SUBSTRATE_WHITE_PAPER_HIGH_TACK,
        SUBSTRATE_WHITE_PLASTIC_SQUEEZABLE
    ],
    [COLOR_5C]: [
        SUBSTRATE_CLEAR_PLASTIC,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC,
        SUBSTRATE_SILVER_METALLIC_PAPER,
        SUBSTRATE_SILVER_METALLIC_PLASTIC,
        SUBSTRATE_CLEAR_VINYL,
        SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
        SUBSTRATE_KRAFT_PAPER,
        SUBSTRATE_BLACK_VELLUM,
        CARTON_METALLIC_PAPER,
        CARTON_HOLOGRAPHIC
    ],
    [COLOR_BLACK_ONLY]: [
        SUBSTRATE_WHITE_PLASTIC,
        SUBSTRATE_WHITE_PLASTIC_REMOVABLE,
        SUBSTRATE_CLEAR_PLASTIC,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC,
        SUBSTRATE_WHITE_PAPER,
        SUBSTRATE_SILVER_METALLIC_PAPER,
        SUBSTRATE_SILVER_METALLIC_PLASTIC,
        SUBSTRATE_WHITE_VINYL,
        SUBSTRATE_CLEAR_VINYL,
        SUBSTRATE_ESTATE4_PAPER,
        SUBSTRATE_ESTATE9_PAPER,
        SUBSTRATE_RECYCLED_PAPER,
        SUBSTRATE_TERRA_SKIN,
        SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
        SUBSTRATE_KRAFT_PAPER,
        SUBSTRATE_AVON_CLASSIC_CREST,
        SUBSTRATE_WHITE_PAPER_HIGH_TACK,
        SUBSTRATE_WHITE_PLASTIC_SQUEEZABLE,
        SUBSTRATE_CUSTOM_MATERIAL,
        CARTON_BRIGHT_WHITE_PAPER,
        CARTON_WHITE_PAPER,
        CARTON_WHITE_PAPER_C2S,
        CARTON_UNLAMINATED_WHITE_PAPER,
        CARTON_METALLIC_PAPER,
        CARTON_HOLOGRAPHIC
    ],
    [COLOR_DOUBLE_SIDED]: [
        SUBSTRATE_CLEAR_PLASTIC,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC,
        SUBSTRATE_CLEAR_VINYL
    ],
    [COLOR_WHITE_ONLY]: [
        SUBSTRATE_SILVER_METALLIC_PLASTIC,
        SUBSTRATE_CLEAR_PLASTIC,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC,
        SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
        SUBSTRATE_KRAFT_PAPER,
        SUBSTRATE_BLACK_VELLUM,
        CARTON_BLACK_VELLUM,
        CARTON_METALLIC_PAPER,
        CARTON_HOLOGRAPHIC
    ]
};

export const TRANSACTION_STATUS_PENDING = 100;
export const TRANSACTION_STATUS_ERROR = 500;
export const TRANSACTION_STATUS_SYNC = 200;

export const TRANSACTION_TYPE_CART = 1;
export const TRANSACTION_TYPE_CHARGE = 2;

export const FILESTACK_SERVICES = ['local_file_system', 'box', 'googledrive', 'dropbox', 'gmail'];

export const NEW_CUSTOM_SHAPE_MIMETYPES = [
    'image/vnd.adobe.photoshop',
    'image/x-photoshop',
    'application/postscript',
    'application/x-photoshop',
    'application/x-indesign',
    'image/bmp',
    'image/tiff',
    'image/jpeg',
    'image/png',
    'application/pdf'
];
export const VARIABLE_DATA_MIMETYPES = [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.google-apps.spreadsheet',
    'application/vnd.apple.numbers',
    'application/vnd.oasis.opendocument.spreadsheet-template'
];
export const DESIGN_UPLOAD_MIMETYPES = [
    'image/vnd.adobe.photoshop',
    'image/x-photoshop',
    'application/postscript',
    'application/x-photoshop',
    'application/x-indesign',
    'image/bmp',
    'image/tiff',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'image/svg+xml'
];

export const COMMENT_FORM_MIMETYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ...DESIGN_UPLOAD_MIMETYPES
];

export const QUOTER_ROUNDED_CORNER = 0;
export const QUOTER_SQUARE_CORNER = 1;
export const QUOTER_NOPREF_CORNER = 2;

export const QUOTER_SHAPE_SQUARE_RECTANGLE = 'square_rectangle';
export const QUOTER_SHAPE_CIRCLE_OVAL = 'circle_oval';
export const QUOTER_SHAPE_CUSTOM = 'custom';
export const QUOTER_SHAPE_PREVIOUSLY_USED = 'previously_used';
export const QUOTER_SHAPE_CHAPSTICK = 'chapstick';
export const QUOTER_SHAPE_POLYGON = 'polygon';
export const QUOTER_SHAPE_TAMPER_SEAL = 'tamper_seal';
export const QUOTER_SHAPE_NEW_SHAPE = 'new_shape';

// These are die ids that have been categorized by hand as selectable "Custom Shapes" in
// the quoter.
export const QUOTER_CUSTOM_SIZES = {
    1741: QUOTER_SHAPE_CHAPSTICK,
    1747: QUOTER_SHAPE_CHAPSTICK,
    1358: QUOTER_SHAPE_CHAPSTICK,
    2807: QUOTER_SHAPE_CHAPSTICK,
    2345: QUOTER_SHAPE_CHAPSTICK,
    7522: QUOTER_SHAPE_CHAPSTICK,
    4412: QUOTER_SHAPE_CHAPSTICK,
    7606: QUOTER_SHAPE_CHAPSTICK,
    1503: QUOTER_SHAPE_POLYGON,
    1655: QUOTER_SHAPE_POLYGON,
    1110: QUOTER_SHAPE_POLYGON,
    1581: QUOTER_SHAPE_POLYGON,
    774: QUOTER_SHAPE_POLYGON,
    1242: QUOTER_SHAPE_POLYGON,
    664: QUOTER_SHAPE_POLYGON,
    2277: QUOTER_SHAPE_TAMPER_SEAL,
    3811: QUOTER_SHAPE_TAMPER_SEAL,
    1746: QUOTER_SHAPE_TAMPER_SEAL,
    2199: QUOTER_SHAPE_TAMPER_SEAL,
    5822: QUOTER_SHAPE_TAMPER_SEAL,
    1693: QUOTER_SHAPE_TAMPER_SEAL,
    2330: QUOTER_SHAPE_TAMPER_SEAL
};

export const LS_KEY_QUEUE_SORT = 'order_queue_sort';
export const LS_KEY_QUEUE_SORT_RESET = 'order_queue_sort_last_reset';

export const PRINTER_PACKING_LIST = 101;
export const PRINTER_LABEL = 102;
export const PRINTER_INNER_LABELS_1 = 231;
export const PRINTER_INNER_LABELS_2 = 232;
export const PRINTER_INNER_LABELS_3 = 235;
export const PRINTER_INNER_LABELS_4 = 234;
export const PRINTER_INNER_LABELS_5 = 994;
export const PRINTER_INNER_CARTON_5 = 993;

export const CLOUD_PRINTERS = [
    {id: PRINTER_PACKING_LIST, label: 'packing list'},
    {id: PRINTER_LABEL, label: 'shipping label'},
    {id: PRINTER_INNER_LABELS_1, label: 'inner labels 1'},
    {id: PRINTER_INNER_LABELS_2, label: 'inner labels 2'},
    {id: PRINTER_INNER_LABELS_3, label: 'inner labels 3'},
    {id: PRINTER_INNER_LABELS_4, label: 'inner labels 4'},
    {id: PRINTER_INNER_LABELS_5, label: 'inner labels 5'},
    {id: PRINTER_INNER_CARTON_5, label: 'Carton Samples 5'}
];

export const CHANNEL_ADS = 1;
export const CHANNEL_ORGANIC = 2;
export const CHANNEL_REFERRAL = 3;
export const CHANNEL_OTHER = 99;

export const CHANNELS = [
    {id: CHANNEL_ADS, label: 'Online Ads'},
    {id: CHANNEL_ORGANIC, label: 'Web Search'},
    {id: CHANNEL_REFERRAL, label: 'Personal Recommendation'},
    {id: CHANNEL_OTHER, label: 'Other'}
];

export const REASON_SPEED = 1;
export const REASON_QUALITY = 2;
export const REASON_SERVICE = 3;
export const REASON_EASY = 4;
export const REASON_RESOURCES = 5;
export const REASON_PRICE = 6;
export const REASON_OTHER = 99;

export const REASONS = [
    {id: REASON_SPEED, label: 'Turnaround Time'},
    {id: REASON_QUALITY, label: 'Quality'},
    {id: REASON_SERVICE, label: 'Customer Service'},
    {id: REASON_EASY, label: 'Ease of Ordering'},
    {id: REASON_RESOURCES, label: 'Blog Resources'},
    {id: REASON_PRICE, label: 'Lowest Price'},
    {id: REASON_OTHER, label: 'Other'}
];

export const REPRINT_NONE = 100;
export const REPRINT_PARTIAL = 500;
export const REPRINT_FULL = 900;
export const REPRINT_UNKNOWN = 999;

export const REPRINT_TYPES = [
    {id: REPRINT_NONE, label: 'No Reprint'},
    {id: REPRINT_PARTIAL, label: 'Partial'},
    {id: REPRINT_FULL, label: 'Full'},
    {id: REPRINT_UNKNOWN, label: 'Unknown'}
];

export const DEPT_EXP = 3;
export const DEPT_PREPRESS = 4;
export const DEPT_PRINTING = 8;
export const DEPT_LAMINATING = 10;
export const DEPT_CONVERTING = 11;
export const DEPT_REWIND = 14;
export const DEPT_SHIPPING = 17;
export const DEPT_GRAPHIC_DESIGN = 34;
export const DEPT_ADMIN = 300;
export const DEPT_UNKNOWN = 999;

export const MISTAKE_DEPARTMENTS = [
    {id: DEPT_EXP, label: 'Care Team'},
    {id: DEPT_GRAPHIC_DESIGN, label: 'Graphic Design'},
    {id: DEPT_PREPRESS, label: 'Prepress'},
    {id: DEPT_PRINTING, label: 'Printing'},
    {id: DEPT_LAMINATING, label: 'Laminating'},
    {id: DEPT_CONVERTING, label: 'Converting'},
    {id: DEPT_REWIND, label: 'Rewind/Folding'},
    {id: DEPT_SHIPPING, label: 'Shipping'},
    {id: DEPT_ADMIN, label: 'Admin'},
    {id: DEPT_UNKNOWN, label: 'Unknown'}
];

export const RECEIVING_STATUS_PENDING = 1;
export const RECEIVING_STATUS_RECEIVED = 2;
export const RECEIVING_STATUS_CANCELLED = 99;
export const RECEIVING_STATUS_CHECKEDIN = 20;

export const INVOICE_STATUS_PENDING = 1;
export const INVOICE_STATUS_SUBMITTED = 2;
export const INVOICE_STATUS_CANCELLED = 99;

// These departments do not align with actual departments in real life
// Trying to make this more explicit
// This probably makes more sense to be called category one day
export const DEPARTMENTS = MISTAKE_DEPARTMENTS;

export const PAYMENT_PROFILE_TYPE_CREDIT = 1;
export const PAYMENT_PROFILE_TYPE_BANK = 2;

export const PAYMENT_ACCOUNT_TYPE_ECHECK = 500;

export const COMMENT_ACCOUNT = 1;
export const COMMENT_BILLING = 2;
export const COMMENT_PREPRINTING = 3;
export const COMMENT_CONVERTING = 4;
export const COMMENT_SHIPPING = 5;
export const COMMENT_PRINTING = 6;
export const COMMENT_CUSTOMER_SERVICE = 7;
export const COMMENT_CUSTOMER = 8;

export const DESIGN_COMMENT_TYPE_PREPRINTING = COMMENT_PREPRINTING;
export const DESIGN_COMMENT_TYPE_PRINTING = COMMENT_PRINTING;
export const DESIGN_COMMENT_TYPE_CUSTOMER = COMMENT_CUSTOMER;
export const DESIGN_COMMENT_TYPE_PROOFING = 100;

export const SAMPLE_REQUEST_SOURCE_WEB = 1;
export const SAMPLE_REQUEST_SOURCE_PHONE = 2;
export const SAMPLE_REQUEST_SOURCE_EMAIL = 3;

export const SAMPLE_REQUEST_SOURCES = [
    {id: SAMPLE_REQUEST_SOURCE_WEB, label: 'Web'},
    {id: SAMPLE_REQUEST_SOURCE_PHONE, label: 'Phone'},
    {id: SAMPLE_REQUEST_SOURCE_EMAIL, label: 'Email'}
];

export const INDUSTRY_TYPE_BEER = 1;
export const INDUSTRY_TYPE_BEVERAGE = 2;
export const INDUSTRY_TYPE_CANDLES = 3;
export const INDUSTRY_TYPE_COFFEE = 4;
export const INDUSTRY_TYPE_EDUCATION = 5;
export const INDUSTRY_TYPE_ELECTRONIC = 6;
export const INDUSTRY_TYPE_EVENT = 7;
export const INDUSTRY_TYPE_FOOD = 8;
export const INDUSTRY_TYPE_MEDICAL = 9;
export const INDUSTRY_TYPE_BEAUTY = 10;
export const INDUSTRY_TYPE_HOTEL = 11;
export const INDUSTRY_TYPE_HOUSEHOLD = 12;
export const INDUSTRY_TYPE_INDUSTRIAL = 13;
export const INDUSTRY_TYPE_INSURANCE = 14;
export const INDUSTRY_TYPE_MARKETING = 15;
export const INDUSTRY_TYPE_NONPROFIT = 16;
export const INDUSTRY_TYPE_PRINT_PAPER = 17;
export const INDUSTRY_TYPE_PET = 18;
export const INDUSTRY_TYPE_RECREATION = 19;
export const INDUSTRY_TYPE_SPIRITS = 20;
export const INDUSTRY_TYPE_SUPPLEMENTS = 21;
export const INDUSTRY_TYPE_TEA = 22;
export const INDUSTRY_TYPE_VAPES = 23;
export const INDUSTRY_TYPE_WINE = 24;
export const INDUSTRY_TYPE_OTHER = 25;
export const INDUSTRY_TYPE_UNDETERMINED = 26;

export const INDUSTRY_TYPES = [
    {id: INDUSTRY_TYPE_BEER, label: 'Beer'},
    {id: INDUSTRY_TYPE_BEVERAGE, label: 'Beverage'},
    {id: INDUSTRY_TYPE_CANDLES, label: 'Candles'},
    {id: INDUSTRY_TYPE_COFFEE, label: 'Coffee'},
    {id: INDUSTRY_TYPE_EDUCATION, label: 'Education'},
    {id: INDUSTRY_TYPE_ELECTRONIC, label: 'Electronic'},
    {id: INDUSTRY_TYPE_EVENT, label: 'Event'},
    {id: INDUSTRY_TYPE_FOOD, label: 'Food'},
    {id: INDUSTRY_TYPE_MEDICAL, label: 'Medical'},
    {id: INDUSTRY_TYPE_BEAUTY, label: 'Beauty'},
    {id: INDUSTRY_TYPE_HOTEL, label: 'Hotel'},
    {id: INDUSTRY_TYPE_HOUSEHOLD, label: 'Household'},
    {id: INDUSTRY_TYPE_INDUSTRIAL, label: 'Industrial'},
    {id: INDUSTRY_TYPE_INSURANCE, label: 'Insurance'},
    {id: INDUSTRY_TYPE_MARKETING, label: 'Marketing'},
    {id: INDUSTRY_TYPE_NONPROFIT, label: 'Nonprofit'},
    {id: INDUSTRY_TYPE_PRINT_PAPER, label: 'Print paper'},
    {id: INDUSTRY_TYPE_PET, label: 'Pet'},
    {id: INDUSTRY_TYPE_RECREATION, label: 'Recreation'},
    {id: INDUSTRY_TYPE_SPIRITS, label: 'Spirits'},
    {id: INDUSTRY_TYPE_SUPPLEMENTS, label: 'Supplements'},
    {id: INDUSTRY_TYPE_TEA, label: 'Tea'},
    {id: INDUSTRY_TYPE_VAPES, label: 'Vapes'},
    {id: INDUSTRY_TYPE_WINE, label: 'Wine'},
    {id: INDUSTRY_TYPE_OTHER, label: 'Other'},
    {id: INDUSTRY_TYPE_UNDETERMINED, label: 'Undetermined'}
];

export const REGULATORY_INDUSTRY_BEER = 10;
export const REGULATORY_INDUSTRY_BEVERAGE = 20;
export const REGULATORY_INDUSTRY_CANDLES = 30;
export const REGULATORY_INDUSTRY_CANNABIS = 40;
export const REGULATORY_INDUSTRY_COSMETICS = 50;
export const REGULATORY_INDUSTRY_COFFEE = 60;
export const REGULATORY_INDUSTRY_DRUGS = 70;
export const REGULATORY_INDUSTRY_ELECTRONIC = 80;
export const REGULATORY_INDUSTRY_FOOD = 90;
export const REGULATORY_INDUSTRY_HOUSEHOLD = 100;
export const REGULATORY_INDUSTRY_MEDICAL = 110;
export const REGULATORY_INDUSTRY_ORGANIC = 120;
export const REGULATORY_INDUSTRY_PET = 130;
export const REGULATORY_INDUSTRY_SELTZER = 140;
export const REGULATORY_INDUSTRY_SOAP = 150;
export const REGULATORY_INDUSTRY_SPIRITS = 160;
export const REGULATORY_INDUSTRY_SUPPLEMENTS = 170;
export const REGULATORY_INDUSTRY_VAPES = 180;
export const REGULATORY_INDUSTRY_WINE = 190;
export const REGULATORY_INDUSTRY_OTHER = 200;
export const REGULATORY_INDUSTRY_NOTAPPLICABLE = 210;

export const REGULATORY_INDUSTRY_TYPES = [
    {id: REGULATORY_INDUSTRY_BEER, label: 'Malt Beverages (Beer)'},
    {id: REGULATORY_INDUSTRY_BEVERAGE, label: 'Beverage'},
    {id: REGULATORY_INDUSTRY_CANDLES, label: 'Candles'},
    {id: REGULATORY_INDUSTRY_CANNABIS, label: 'Cannabis/CBD'},
    {id: REGULATORY_INDUSTRY_COSMETICS, label: 'Cosmetics'},
    {id: REGULATORY_INDUSTRY_COFFEE, label: 'Coffee/Tea'},
    {id: REGULATORY_INDUSTRY_DRUGS, label: 'Drug Products'},
    {id: REGULATORY_INDUSTRY_ELECTRONIC, label: 'Electronics'},
    {id: REGULATORY_INDUSTRY_FOOD, label: 'Food'},
    {id: REGULATORY_INDUSTRY_HOUSEHOLD, label: 'Household (Chemical)'},
    {id: REGULATORY_INDUSTRY_MEDICAL, label: 'Medical'},
    {id: REGULATORY_INDUSTRY_ORGANIC, label: 'Organic'},
    {id: REGULATORY_INDUSTRY_PET, label: 'Pet Products'},
    {id: REGULATORY_INDUSTRY_SELTZER, label: 'Hard Seltzer'},
    {id: REGULATORY_INDUSTRY_SOAP, label: 'Soap'},
    {id: REGULATORY_INDUSTRY_SPIRITS, label: 'Distilled Spirits'},
    {id: REGULATORY_INDUSTRY_SUPPLEMENTS, label: 'Supplements'},
    {id: REGULATORY_INDUSTRY_VAPES, label: 'Tobacco/Vapes'},
    {id: REGULATORY_INDUSTRY_WINE, label: 'Wine'},
    {id: REGULATORY_INDUSTRY_OTHER, label: 'Other'},
    {id: REGULATORY_INDUSTRY_NOTAPPLICABLE, label: 'Not Applicable'}
];

export const ROLL_SIZE_TYPE_QTY = 1;
export const ROLL_SIZE_TYPE_DIAMETER = 2;

// use for pusher download statuses
export const DOWNLOAD_STATUS_PENDING = 'pending';
export const DOWNLOAD_STATUS_ERROR = 'error';
export const DOWNLOAD_STATUS_COMPLETE = 'complete';

export const CONTACT_TYPE_SUPPORT = 1;
export const CONTACT_TYPE_FEEDBACK = 2;

// Order Entity
export const TIMELINE_CUSTOMER_DESIGN = 1;
export const TIMELINE_PRESSREADY_DESIGN = 2;
export const TIMELINE_DESIGN_STATUS_CHANGE = 3;
export const TIMELINE_DESIGN_VERSION = 4;
export const TIMELINE_COMMENT = 5;
export const TIMELINE_PROOFING_STARTED = 6;
export const TIMELINE_PROOFING_STOPPED = 7;
export const TIMELINE_PROOFING_TASK = 8;

export const MATERIAL_GLOSSY = 1;
export const MATERIAL_SEMI = 2;
export const MATERIAL_MATTE = 3;

export const COLOR_CYAN = 1;
export const COLOR_MAGENTA = 2;
export const COLOR_YELLOW = 3;
export const COLOR_BLACK = 4;
export const COLOR_ORANGE = 5;
export const COLOR_VIOLET = 6;
export const COLOR_GREEN = 7;
export const COLOR_STD_WHITE = 8;

export const CALIBRATION_MATERIALS = [
    {
        id: MATERIAL_GLOSSY,
        label: 'Glossy'
    },
    {
        id: MATERIAL_SEMI,
        label: 'Semi Matte'
    },
    {
        id: MATERIAL_MATTE,
        label: 'Matte'
    }
];

export const CALIBRATION_COLORS = [
    // {
    //     id: COLOR_ORANGE,
    //     field: 'orange',
    //     label: 'Orange',
    //     hex: '#ffa500'
    // },
    {
        id: COLOR_BLACK,
        field: 'black',
        label: 'Black',
        hex: '#000000'
    },
    {
        id: COLOR_CYAN,
        field: 'cyan',
        label: 'Cyan',
        hex: '#00FFFF'
    },
    {
        id: COLOR_MAGENTA,
        field: 'magenta',
        label: 'Magenta',
        hex: '#ff00ff'
    },
    // {
    //     id: COLOR_VIOLET,
    //     field: 'violet',
    //     label: 'Violet',
    //     hex: '#8a2be2'
    // },
    {
        id: COLOR_YELLOW,
        field: 'yellow',
        label: 'Yellow',
        hex: '#ffff00'
    }
    // {
    //     id: COLOR_STD_WHITE,
    //     field: 'std_white',
    //     label: 'Std White',
    //     hex: '#FFFFFF'
    // },
    // {
    //     id: COLOR_GREEN,
    //     field: 'green',
    //     label: 'Green',
    //     hex: '#00ff00'
    // }
];

export const DENSITY_TARGETS = {
    [MATERIAL_GLOSSY]: {
        material_id: MATERIAL_GLOSSY,
        label: 'Glossy',
        colors: {
            [COLOR_CYAN]: 1.45,
            [COLOR_MAGENTA]: 1.45,
            [COLOR_YELLOW]: 1,
            [COLOR_BLACK]: 1.75,
            [COLOR_ORANGE]: 1.9,
            [COLOR_VIOLET]: 1.45,
            [COLOR_GREEN]: 1.4,
            [COLOR_STD_WHITE]: 0.5
        }
    },
    [MATERIAL_SEMI]: {
        material_id: MATERIAL_SEMI,
        label: 'Semi-Matte',
        colors: {
            [COLOR_CYAN]: 1.3,
            [COLOR_MAGENTA]: 1.3,
            [COLOR_YELLOW]: 0.91,
            [COLOR_BLACK]: 1.5,
            [COLOR_ORANGE]: 1.65,
            [COLOR_VIOLET]: 1.3,
            [COLOR_GREEN]: 1.25,
            [COLOR_STD_WHITE]: 0.5
        }
    },
    [MATERIAL_MATTE]: {
        material_id: MATERIAL_MATTE,
        label: 'Matte',
        colors: {
            [COLOR_CYAN]: 1.1,
            [COLOR_MAGENTA]: 1.1,
            [COLOR_YELLOW]: 0.9,
            [COLOR_BLACK]: 1.2,
            [COLOR_ORANGE]: 1.35,
            [COLOR_VIOLET]: 1.1,
            [COLOR_GREEN]: 1.05,
            [COLOR_STD_WHITE]: 0.5
        }
    }
};

export const MACHINE_TYPE_PRESS = 1;
export const MACHINE_TYPE_LAMINATOR = 2;
export const MACHINE_TYPE_CONVERTER = 3;

export const PRESS_TEST = 99;
export const PRESS_RMT1 = 90;
export const PRESS_RMT2 = 91;
export const PRESS_IRONMAN = 1;
export const PRESS_THOR = 2;
export const PRESS_HULK = 3;
export const PRESS_VISION = 253;
export const PRESS_VALKIE = 248;
export const PRESS_OBIWAN = 21;

export const PRESSES = [
    {
        id: PRESS_IRONMAN,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Iron Man',
        product_type_id: 1
    },
    {
        id: PRESS_THOR,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Thor',
        product_type_id: 1
    },
    {
        id: PRESS_HULK,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Hulk',
        product_type_id: 1
    },
    {
        id: PRESS_OBIWAN,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Obi Wan',
        product_type_id: 2
    },
    {
        id: PRESS_VALKIE,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Valkyrie',
        product_type_id: 1
    },
    {
        id: PRESS_VISION,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Vision',
        product_type_id: 1
    },
    {
        id: PRESS_TEST,
        type_id: MACHINE_TYPE_PRESS,
        label: 'TESTING'
    },
    {
        id: PRESS_RMT1,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Bennett 100k'
    },
    {
        id: PRESS_RMT2,
        type_id: MACHINE_TYPE_PRESS,
        label: 'Bennett 12k'
    }
];

export const REMOTE_PRESSES = PRESSES.filter(({id}) =>
    [PRESS_RMT1, PRESS_RMT2, PRESS_TEST].includes(id)
);

export const OPTIMUS_PRIME_LAMINATOR = 225;
export const GRIMLOCK_LAMINATOR = 224;
export const BUMBLEBEE_ABG2019 = 223;
export const RATCHET_ABG2015 = 222;
export const MEGATRON_ABG2007 = 221;
export const BLAZE_GRAFATRONICS2023 = 226;
export const MACHINE_LAM_LINK = 227;
export const MACHINE_DIE_DOZER = 228;
export const MACHINE_FOLDER_NEO = 229;
export const MACHINE_BLANKER_APOC = 230;
export const MACHINE_DUOBLADE_DRIFT = 231;

export const MACHINES = [
    {
        id: GRIMLOCK_LAMINATOR,
        label: 'Grimlock',
        product_type_id: 1
    },
    {
        id: OPTIMUS_PRIME_LAMINATOR,
        label: 'Optimus Prime',
        product_type_id: 1
    },
    {
        id: BUMBLEBEE_ABG2019,
        label: 'Bumblebee',
        type_id: MACHINE_TYPE_CONVERTER,
        product_type_id: 1
    },
    {
        id: RATCHET_ABG2015,
        label: 'Ratchet',
        type_id: MACHINE_TYPE_CONVERTER,
        product_type_id: 1
    },
    {
        id: MACHINE_DUOBLADE_DRIFT,
        label: 'Drift',
        type_id: MACHINE_TYPE_CONVERTER,
        product_type_id: 1
    },
    {
        id: MEGATRON_ABG2007,
        label: 'Megatron'
    },
    {
        id: BLAZE_GRAFATRONICS2023,
        label: 'Blaze',
        type_id: MACHINE_TYPE_CONVERTER,
        product_type_id: 1
    },
    {id: MACHINE_LAM_LINK, label: 'Link', product_type_id: PRODUCT_TYPE_CARTON},
    {id: MACHINE_DIE_DOZER, label: 'Dozer', product_type_id: PRODUCT_TYPE_CARTON},
    {id: MACHINE_FOLDER_NEO, label: 'Neo', product_type_id: PRODUCT_TYPE_CARTON},
    {id: MACHINE_BLANKER_APOC, label: 'Apoc', product_type_id: PRODUCT_TYPE_CARTON},
    {
        id: PRESS_TEST,
        label: 'TESTING'
    }
];

export const SCANNER_TYPE_I1ISIS2 = 1;
export const SCANNER_TYPE_I1PRO = 2;

export const SCANNER_TYPES = [
    {id: SCANNER_TYPE_I1ISIS2, label: 'i1iSis XL 2'},
    {id: SCANNER_TYPE_I1PRO, label: 'i1Pro'}
];

export const CONVERTER_TYPE_DIE = 1;
export const CONVERTER_TYPE_DRAG_KNIFE = 2;

export const DRAG_KNIFE_LENGTH_LIMIT = 11;

export const CONVERTER_TYPES = [
    {id: CONVERTER_TYPE_DIE, label: 'Die Cutter'},
    {id: CONVERTER_TYPE_DRAG_KNIFE, label: 'Drag Knife'}
];

export const ALL_MACHINES = [...PRESSES, ...MACHINES];
export const ALL_REAL_MACHINES = [...PRESSES, ...MACHINES].filter(
    press => press?.product_type_id > 0
);

// +/- Tolerance
export const OPTICAL_DENSITY_TOLERANCE = 0.05;
export const CALIBRATION_TOLERANCE = 0.05;
// Must be less tLUT_OPTIONShan this
export const OPTICAL_DENSITY_UNIFORMITY_TOLERANCE = 0.15;

export const CALIBRATION_FIELD = 'calibration';
export const OPTICAL_DENSITY_FIELD = 'density';
export const UNIFORMITY_FIELD = 'uniform';

export const CALIBRATION_FIELDS = [
    {
        id: CALIBRATION_FIELD,
        label: 'Calibration'
    },
    {
        id: OPTICAL_DENSITY_FIELD,
        label: 'Optical Density AVG'
    },
    {
        id: UNIFORMITY_FIELD,
        label: 'Uniformity'
    }
];

export const SUPPLY_STATUS_UNUSED = 1;
export const SUPPLY_STATUS_USED = 2;
export const STATUS_LOST = 3;
export const STATUS_BAD = 4;

export const SUPPLY_STATUSES = [
    {id: SUPPLY_STATUS_UNUSED, label: 'Unused'},
    {id: SUPPLY_STATUS_USED, label: 'Used'},
    {id: STATUS_LOST, label: 'Lost'},
    {id: STATUS_BAD, label: 'Bad'}
];

export const OPERATOR_ADMIN = 25;
export const OPERATOR_BILLING = 200;
export const OPERATOR_EXP_TEAM = 300;
export const OPERATOR_PREPRESS = 400;
export const OPERATOR_PRINTING = 800;
export const OPERATOR_CONVERTING = 1100;
export const OPERATOR_FOLDER = 1200;
export const OPERATOR_LAMINATOR = 1300;
export const OPERATOR_SHIPPING = 1800;
export const OPERATOR_GRAPHIC_DESIGN = 1900;

export const OPERATOR_TYPES = [
    {id: OPERATOR_ADMIN, label: 'Admin'},
    {id: OPERATOR_BILLING, label: 'Billing'},
    {id: OPERATOR_EXP_TEAM, label: 'Care Team'},
    {id: OPERATOR_PREPRESS, label: 'Prepress'},
    {id: OPERATOR_PRINTING, label: 'Printing'},
    {id: OPERATOR_CONVERTING, label: 'Converting'},
    {id: OPERATOR_FOLDER, label: 'Folder'},
    {id: OPERATOR_LAMINATOR, label: 'Laminator'},
    {id: OPERATOR_SHIPPING, label: 'Shipping'},
    {id: OPERATOR_GRAPHIC_DESIGN, label: 'Graphic Design'}
];

export const CAN_SCHEDULE_JOBS = [OPERATOR_ADMIN, OPERATOR_EXP_TEAM, OPERATOR_PREPRESS];

export const CAN_MANUALLY_CHANGE_STATUS = [
    OPERATOR_ADMIN,
    OPERATOR_EXP_TEAM,
    OPERATOR_PREPRESS,
    OPERATOR_GRAPHIC_DESIGN,
    OPERATOR_BILLING
];

export const CAN_COMPLETE_ORDERS = [OPERATOR_EXP_TEAM];

export const CAN_OVERRIDE_SHIPDATE_BASELINE = CAN_MANUALLY_CHANGE_STATUS;

export const CAN_CHANGE_OPERATOR_TYPE = CAN_MANUALLY_CHANGE_STATUS;

export const PRODUCTION_OPERATORS = [
    OPERATOR_PRINTING,
    OPERATOR_CONVERTING,
    OPERATOR_FOLDER,
    OPERATOR_LAMINATOR,
    OPERATOR_SHIPPING
];

export const CALIBRATION_OPTION_VERIFICATION = 1;
export const CALIBRATION_OPTION_PROFILE = 2;
export const CALIBRATION_OPTION_CORRECTION = 3;

export const CALIBRATION_OPTIONS = [
    {id: CALIBRATION_OPTION_VERIFICATION, label: 'Standard Check'},
    {id: CALIBRATION_OPTION_PROFILE, label: 'Profile'},
    {id: CALIBRATION_OPTION_CORRECTION, label: 'Hydrafix'}
];

export const PRINTER_SHIPPING_PACKING_1 = 111;
export const PRINTER_SHIPPING_LABEL_1 = 112;
export const PRINTER_SHIPPING_LABEL_2 = 236;
export const PRINTER_SHIPPING_PACKING_2 = 237;
export const PRINTER_SHIPPING_CARTON_PACKING_3 = 238;
export const PRINTER_SHIPPING_CARTON_LABEL_3 = 239;
export const PRINTER_CARTON_BOX_COUNT = 240;
export const PRINTER_DESIGN_TAG_1 = 241;
export const PRINTER_DESIGN_TAG_2 = 242;
export const PRINTER_DESIGN_TAG_3 = 243;

export const SHIPMENT_STATUS_INPROGRESS = 2;
export const SHIPMENT_STATUS_COMPLETE = 3;

export const SHIPPING_PROIVDER_UPS = 'ups';
export const SHIPPING_PROVIDER_FREIGHT = 'freightquote';
export const SHIPPING_PROVIDER_FEDEX = 'fedex';
export const SHIPPING_PROVIDER_NONE = '';

export const PRINT_TAG_FIELDS = [
    [{value: 'order_id'}, {value: 'created'}],
    [{value: 'frame_file_name'}, {value: 'qty_on_roll'}, {value: 'current_user_id'}]
];

export const ORDER_PRIORITY_SORT = [
    'sort_red_expedite:desc',
    'sort_yellow_expedite:desc',
    'sort_red_priority:desc',
    'sort_red:desc',
    'sort_yellow_priority:desc',
    'sort_yellow:desc',
    'sort_white_expedite:desc',
    'sort_due_time:asc',
    'sort_white_priority:desc',
    'id:asc'
];

export const QB_TYPE_SALES_RECEIPT = 1;
export const QB_TYPE_REFUND = 2;
export const QB_TYPE_PAYMENT = 3;

const SIZE_CONSTRAINTS = {
    [SHAPE_CIRCLE]: {
        min: {width: 0.5, length: 0.5, width_length: 1},
        max: {width: 12, length: 23.25, width_length: 204}
    },
    [SHAPE_CARTON_AUTOLOCK]: {
        min: {length: 1.5, width: 1.5, depth: 3, width_length: 3},
        max: {length: 100, width: 100, depth: 11.75, width_length: 9}
    },
    [SHAPE_CARTON_STRAIGHT_TUCK]: {
        min: {length: 0.375, width: 0.375, depth: 1.25, width_length: 1.625},
        max: {length: 100, width: 100, depth: 11.75, width_length: 9.875}
    }
};

SIZE_CONSTRAINTS[SHAPE_CARTON_CUSTOM] = SIZE_CONSTRAINTS[SHAPE_CARTON_STRAIGHT_TUCK];

SIZE_CONSTRAINTS[SHAPE_RECTANGLE] = SIZE_CONSTRAINTS[SHAPE_CIRCLE];
SIZE_CONSTRAINTS[SHAPE_SQUARE] = SIZE_CONSTRAINTS[SHAPE_CIRCLE];
SIZE_CONSTRAINTS[SHAPE_OVAL] = SIZE_CONSTRAINTS[SHAPE_CIRCLE];
SIZE_CONSTRAINTS[SHAPE_CUSTOM] = SIZE_CONSTRAINTS[SHAPE_CIRCLE];

export {SIZE_CONSTRAINTS};

const DESIGN_ALERT_SEVERITY_DANGER = 1;
const DESIGN_ALERT_SEVERITY_WARNING = 2;
const DESIGN_ALERT_SEVERITY_INFO = 3;

export const DESIGN_ALERT_SEVERITIES = [
    {id: DESIGN_ALERT_SEVERITY_DANGER, label: 'Danger'},
    {id: DESIGN_ALERT_SEVERITY_WARNING, label: 'Warning'},
    {id: DESIGN_ALERT_SEVERITY_INFO, label: 'Info'}
];

export const DESIGN_ALERT_SEVERITIES_ICON = [
    {id: DESIGN_ALERT_SEVERITY_DANGER, icon: 'danger'},
    {id: DESIGN_ALERT_SEVERITY_WARNING, icon: 'warning'},
    {id: DESIGN_ALERT_SEVERITY_INFO, icon: 'info'}
];

// See Order.php for similar constant
// Used in determining split orders
export const ORDER_SPLIT_MINUTES = 240;
// Cartons has a max of 1200 sheets
export const ORDER_SPLIT_SHEETS = 1200;

export const BATCH_STATUS_PENDING = 1;
export const BATCH_STATUS_COMPLETE = 20;

export const COMMON_CORE_SIZES = [0.99, 1.85, 2.1, 2.35, 2.6, 3.1, 4.1];

export const MACHINE_CURRENT_STATE = 99;
export const MACHINE_LAST_IMPRESSION = 100;

export const BLANKET_TOTAL_IMPRESSIONS = 1;
export const BLANKET_CHANGED_IMPRESSION = 2;
export const BLANKET_CHANGED_DATETIME = 3;
export const PIP_TOTAL_IMPRESSIONS = 4;
export const PIP_CHANGED_IMPRESSION = 5;
export const PIP_CHANGED_DATETIME = 6;
export const ROLL_TOTAL_IMPRESSIONS = 7;
export const ROLL_CHANGED_IMPRESSION = 8;
export const ROLL_CHANGED_DATETIME = 9;
export const COLOR_CALIBRATION_TOTAL_IMPRESSIONS = 10;
export const COLOR_CALIBRATION_CHANGED_IMPRESSION = 11;
export const COLOR_CALIBRATION_CHANGED_DATETIME = 12;
export const CHARGE_ROLLER_TOTAL_IMPRESSIONS = 13;
export const CHARGE_ROLLER_CHANGED_IMPRESSION = 14;
export const CHARGE_ROLLER_CHANGED_DATETIME = 15;

export const BID_WHITE_IMPRESSIONS = 16;
export const BID_WHITE_DATETIME = 17;
export const BID_CYAN_IMPRESSIONS = 18;
export const BID_CYAN_DATETIME = 19;
export const BID_MAGENTA_IMPRESSIONS = 20;
export const BID_MAGENTA_DATETIME = 21;
export const BID_YELLOW_IMPRESSIONS = 22;
export const BID_YELLOW_DATETIME = 23;
export const BID_BLACK_IMPRESSIONS = 24;
export const BID_BLACK_DATETIME = 25;

export const COLOR_CALIBRATION_SUBSTRATE_SKU = 26;
export const COLOR_CALIBRATION_SUBSTRATE_LABEL = 27;
export const COLOR_CALIBRATION_DATETIME = 28;

export const LOADED_SUBSTRATE_SKU = 29;
export const LOADED_SUBSTRATE_LABEL = 30;
export const LOADED_SUBSTRATE_DATETIME = 31;

export const UNIT_TYPE_ROLL = 1;
export const UNIT_TYPE_SKID = 2;
export const UNIT_TYPE_BOX = 3;
export const UNIT_TYPE_BUNDLE = 4;

export const UNIT_TYPES = [
    {id: UNIT_TYPE_ROLL, label: 'Roll'},
    {id: UNIT_TYPE_SKID, label: 'Skid'},
    {id: UNIT_TYPE_BOX, label: 'Box'},
    {id: UNIT_TYPE_BUNDLE, label: 'Bundle'}
];

// Helper function to get the label by its constant value.
export const getUnitTypeLabel = value => {
    const type = UNIT_TYPES.find(option => option.id === value);
    return type ? type.label : null;
};

// Unit Measurements
export const UNIT_MEASUREMENT_FEET = 1;
export const UNIT_MEASUREMENT_SHEETS = 2;
export const UNIT_MEASUREMENT_BOXES = 3;
export const UNIT_MEASUREMENT_ITEMS = 4;

export const UNIT_MEASUREMENTS = [
    {id: UNIT_MEASUREMENT_FEET, label: 'Feet'},
    {id: UNIT_MEASUREMENT_SHEETS, label: 'Sheets'},
    {id: UNIT_MEASUREMENT_BOXES, label: 'Boxes'},
    {id: UNIT_MEASUREMENT_ITEMS, label: 'Items'}
];

// Helper function to get the measurement label by its constant value.
export const getUnitMeasurementLabel = value => {
    const measurement = UNIT_MEASUREMENTS.find(option => option.id === value);
    return measurement ? measurement.label : null;
};

// Sheet dimensions in inches (converted from mm)
export const SHEET_LEADING_EDGE_WIDTH = 750 / 25.4;
export const SHEET_NON_LEADING_EDGE_WIDTH = 530 / 25.4;
